import type { App } from 'vue';
import {
  // Need
  Button,
  Input,
  Layout,
  Space,
} from 'ant-design-vue';

// const compList = [AntButton.Group];
const compList = [Space];

export function registerGlobComp(app: App) {
  compList.forEach((comp) => {
    // debugger;
    app.component(comp.name || comp.displayName, comp);
  });

  app.use(Input).use(Button).use(Layout);
}
